/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Row } from "react-bootstrap";
import LazyImage from "react-lazy-blur-image";

const Card = (props) => {
  const { item } = props;

  const cycling = "/media/assets/svg/directions-bike.svg";
  const walking = "/media/assets/svg/directions-walk.svg";
  const running = "/media/assets/svg/directions-run.svg";

  const handleButtonClick = (value) => {
    window.location.href = value;
  };

  return (
    <>
      <div className="col-md-6 col-xl-4 mb-4 move-up">
        <div
          className="image-container"
          onClick={() => {
            handleButtonClick(item.pageURL);
          }}
        >
          {/* <img
            src={
              item.webBannerImage
                ? item.webBannerImage
                : "https://placehold.co/403x268?text=N/A"
            }
            alt="backgroundimage"
            className="img-fluid rounded-4 geadient"
            width={500}
            height={310}
          /> */}
          <LazyImage
            uri={
              item.webBannerImage
                ? item.webBannerImage
                : "https://placehold.co/403x268?text=N/A"
            }
            placeholder={
              item.webBannerImage
                ? item.webBannerImage
                : "https://placehold.co/403x268?text=N/A"
            }
            render={(src, style) => (
              <img
                alt="BannerImage"
                src={src}
                style={style}
                className="img-fluid rounded-4 geadient"
                width={500}
                height={310}
              />
            )}
          />
          <div className="gradient-overlay rounded-4"></div>
          <div className="d-flex align-items-center position-absolute rounded-pill border-white gap-1 top-0 my-3 mx-3 end-0 bedge px-2">
            <img
              src={
                item?.eventTypeID === 1
                  ? cycling
                  : item?.eventTypeID === 2
                  ? walking
                  : item?.eventTypeID === 3
                  ? running
                  : ""
              }
              height={20}
              width={28}
            />
            <p className="text text-uppercase text-dark my-1 plus-jakarta-sans-font">
              {item.eventTypeName}
            </p>
          </div>
          <Row>
            <div className="col-auto d-flex flex-column align-items-start position-absolute bottom-0 start-0 mx-2 my-3">
              <h4 className="text-white plus-jakarta-sans-font  mobile-truncate">
                {item?.eventName}
              </h4>
              <div className="text-white fs-6 multi-line-text-truncate text-start plus-jakarta-sans-font">
                {item?.description}
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Card;
